import verifyTokenGuardWithoutPermission from "@/guards/verifyTokenGuardWithoutPermission";

export default {
    name: 'certificate-health-status',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: 'create/:patient_id',
            name: 'certificate-health-status-create',
            beforeEnter: [verifyTokenGuardWithoutPermission],
            meta: {
                breadcrumbs: [
                    {
                        route: {
                            name: 'patients-index',
                        },
                        transKey: 'breadcrumbs.patients-index',
                        isActive: false
                    },
                    {
                        route: {
                            name: 'digital-record-index',
                        },
                        params: ["patient_id"],
                        transKey: 'breadcrumbs.clinical-history',
                        isActive: false,
                    },
                    {
                        transKey: 'breadcrumbs.certificate-health-status',
                        isActive: true,
                    }
                ]
            },
            component: () => import('@/modules/digital-record/medical-reports/certificate-health-status/views/Create.vue')
        },
        {
            path: 'edit/:patient_id/:id',
            name: 'certificate-health-status-edit',
            beforeEnter: [verifyTokenGuardWithoutPermission],
            meta: {
                breadcrumbs: [
                    {
                        route: {
                            name: 'patients-index',
                        },
                        transKey: 'breadcrumbs.patients-index',
                        isActive: false
                    },
                    {
                        route: {
                            name: 'digital-record-index',
                        },
                        params: ["patient_id"],
                        transKey: 'breadcrumbs.clinical-history',
                        isActive: false,
                    },
                    {
                        transKey: 'breadcrumbs.certificate-health-status',
                        isActive: true,
                    }
                ]
            },
            component: () => import('@/modules/digital-record/medical-reports/certificate-health-status/views/Edit.vue')
        },
        {
            path: 'view/:patient_id/:id',
            name: 'certificate-health-status-view',
            beforeEnter: [verifyTokenGuardWithoutPermission],
            meta: {
                breadcrumbs: [
                    {
                        route: {
                            name: 'patients-index',
                        },
                        transKey: 'breadcrumbs.patients-index',
                        isActive: false
                    },
                    {
                        route: {
                            name: 'digital-record-index',
                        },
                        params: ["patient_id"],
                        transKey: 'breadcrumbs.clinical-history',
                        isActive: false,
                    },
                    {
                        transKey: 'breadcrumbs.certificate-health-status',
                        isActive: true,
                    }
                ]
            },
            component: () => import('@/modules/digital-record/medical-reports/certificate-health-status/views/View.vue')
        }
    ]
}